import type { ReactNode } from 'react';

import { useDocumentTitle } from '@/hooks/useDocumentTitle';

import { SectionWrapper } from './SectionWrapper';

import styles from './TextPage.module.css';

interface TextPageProps {
  children: ReactNode;
  title: string;
  /** The date the page's words were last changed, as "November 2, 2026". */
  updated?: string;
}

/** A public page of plain words: Contact, Privacy and Accessibility (#175). */
export function TextPage({ children, title, updated }: TextPageProps) {
  useDocumentTitle(title);

  return (
    <SectionWrapper background="white" className={styles.section}>
      <article className={styles.page}>
        <h1 className={styles.title}>{title}</h1>
        {children}
        {updated ? <p className={styles.updated}>Last updated {updated}.</p> : null}
      </article>
    </SectionWrapper>
  );
}
